import { BaseError } from './base.js';
export class QuotaError extends BaseError {
    code;
    httpStatus = 403;
    constructor(code, message, options) {
        super(code, message, options);
        this.code = code;
    }
}
